export enum BloodGroupEnum { 
    APositive = "A +ve",
    ANegative = "A -ve",
    OPositive = "O +ve",
    ONegative = "O -ve",
    BPositive = "B +ve",
    BNegative = "B -ve",
    ABPositive = "AB +ve",
    ABNegative = "AB -ve",
  }